import { GetServerSideProps } from 'next';
import { MemberTimeProvider } from 'lowcode/utils/context/memberTimeZone';
import MemberGloData from 'lowcode/utils/MemberGloData';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ReceiveCompoment from '@/components/Referral/Receive';
import { ReferralProvider } from '@/components/Referral/ReferralProvider';
import { MonthlyProvider } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import SEOlinksA from '@/components/SEOlinksA';
import CountDown from '@/components/Referral/Common/CountDown';

const ReferralRewards: React.FC<any> = ({ SEO, isLogin }) => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');

    return (
        <>
            <SEO title={t('seo.title')} description={t('seo.desc')} />
            <SEOlinksA
                locale={locale}
                list={['eu', 'uk', 'it', 'es', 'fr', 'de', 'au', 'kr', 'ca', 'us', 'za', 'jp', 'mx', 'br', 'ph']}
                pathname={'referral-rewards'}
            />
            <PageLayout>
                <MemberTimeProvider>
                    <MemberGloData isOpenA={true} />
                    <MonthlyProvider>
                        <ReferralProvider>
                            {['us', 'ca'].includes(locale) && <CountDown />}
                            <ReceiveCompoment isLogin={isLogin} />
                        </ReferralProvider>
                    </MonthlyProvider>
                </MemberTimeProvider>
            </PageLayout>
        </>
    );
};

export default ReferralRewards;

export const getServerSideProps: GetServerSideProps = async ({ locale, req }) => {
    const whiteLocaleList = ['eu', 'uk', 'it', 'es', 'fr', 'de', 'au', 'kr', 'ca', 'us', 'za', 'jp', 'mx', 'br', 'ph'];
    if (!whiteLocaleList.includes(locale as string)) {
        return { notFound: true };
    }
    // 获取登陆信息
    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    return {
        props: {
            isLogin,
        },
    };
};
